<style lang="scss" src='./MicroWeatherItem.scss' scoped ></style>
<template src="./MicroWeatherItem.html"></template>

<script>
import moment from 'moment';
import i18n from '@/i18n/i18n';

import { mapState } from "vuex";

export default {
  name: "MicroWeatherItem",
  components: {},
  props: {
    weather: {
      required: true,
    },
    title: {
      required: true,
    },
    local: {
      required: false,
    },
    micro: {
      required: false,
    },
    precipitation: {
      required: false
    },
    station: {
      required: false
    },
    dailyTemps: {
      required: false,
    },
  },
  data() {
    return {
      uomSystem: null
    };
  },
  computed: {
    sunrise: function () {
      return this.getSunriseOrSet('sunrise');
    },
    sunset: function () {
      return this.getSunriseOrSet('sunset');
    },
     forecasts: function () {
       if (this.weather && this.weather.daily && this.weather.daily.length) {
         const lastIndex = this.weather.daily.length > 6 ? 6 : this.weather.daily.length;
         return this.weather.daily.slice(1, lastIndex);
       }
      return null;
    },

  },

  methods: {
    getSunriseOrSet(sunRiseSet) {
      if (this.weather && this.weather.current && this.weather.current[sunRiseSet]) {
         return this.G_formatDate({date: this.weather.current[sunRiseSet] * 1000, pretty: false, noHour: false, justHour: true});
      }
      return '';
    },

    goToStation(){
      this.$store.commit('setStation', this.station);
      this.$router.push('/station-details');
    }
  },

  beforeCreate() {},

  created() {
    this.uomSystem = this.consts.UOM_SYSTEMS.find(
          (uomS) => uomS.name === this.$store.state.course.measurement_system
      )[this.consts.UOM.PRECIPITATION]
  },

  mounted() {
    console.log('dailyTemps', this.dailyTemps);
  },
};
</script>
